import { render, staticRenderFns } from "./ArchivedRecords.vue?vue&type=template&id=6963fe17&scoped=true&"
import script from "./ArchivedRecords.vue?vue&type=script&lang=js&"
export * from "./ArchivedRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6963fe17",
  null
  
)

export default component.exports